import { Injectable } from '@angular/core';
import { BaseSseService } from '@libs/shared/services/base-sse.service';
import { SseAccessTokenProvider } from '@sprint-backoffice/app/core/sse/sse-access-token-provider.service';
import { injectCoreFeature } from '@sprint-backoffice/app/core/state/core.store';
import { environment } from '@sprint-backoffice/environments/environment';

@Injectable({ providedIn: 'root' })
export class SseService extends BaseSseService {
  readonly core = injectCoreFeature();

  constructor(protected override accessTokenProvider: SseAccessTokenProvider) {
    super(accessTokenProvider, environment);
  }

  protected handleEvent(eventType: string, data: any): void {
    switch (eventType) {
      case 'AppStatus':
        this.core.fetchAppStatus();
        break;
      case 'PopulateAllDocumentsLock':
        this.core.checkPopulateAllDocumentsLock();
        break;
      case 'heartbeat':
        break;
      default:
        console.error(
          `ExpertSseService: Unhandled event type: ${eventType}`,
          data
        );
    }
  }
}
